import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import PublicFormBuilder from "../../pages/PublicFormBuilder";

const AddContactModal = ({ show, handleClose, handleSave, data }) => {
  const [formData, setFormData] = useState(data?.card_form_builder || []);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...data, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // const validate = () => {
  //   const newErrors = {};
  //   if (!data.name.trim()) newErrors.name = "Name is required";
  //   if (!data.email.trim()) {
  //     newErrors.email = "Email is required";
  //   } else if (!/\S+@\S+\.\S+/.test(data.email)) {
  //     newErrors.email = "Email is invalid";
  //   }
  //   if (!data.phone.trim()) newErrors.phone = "Phone number is required";
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // const onSave = () => {
  //   if (validate()) {
  //     handleSave(data);
  //     handleClose();
  //     setData({ name: "", email: "", phone: "" });
  //     setErrors({});
  //   }
  // };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="md"
      className="customModal "
    >
      <Modal.Header className="modalHeader d-flex justify-content-end border-bottom-0">
        {/* <span className="modalHeading">Add Contact</span> */}
        {/* <div className="modalGradientCircle"></div> */}
        <MdClose
          onClick={() => {
            handleClose();
            setErrors({});
          }}
          className="modalCloseBtn"
        />
      </Modal.Header>

      <Modal.Body className="pt-0">
        {/* <div className="mb-3">
          <label className="form-label" style={{ fontSize: "13px" }}>
            Name
          </label>
          <input
            type="text"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            name="name"
            value={data.name}
            onChange={handleChange}
            placeholder="Enter name"
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "13px" }}>
            Email
          </label>
          <input
            type="email"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            name="email"
            value={data.email}
            onChange={handleChange}
            placeholder="Enter email"
          />
          {errors.email && (
            <div className="invalid-feedback">{errors.email}</div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "13px" }}>
            Phone Number
          </label>
          <input
            type="tel"
            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
            name="phone"
            value={data.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
          />
          {errors.phone && (
            <div className="invalid-feedback">{errors.phone}</div>
          )}
        </div> */}
        {console.log("formData", data?.id)}
        <PublicFormBuilder
          formBuilderData={formData}
          formBuilderDataId={data?.id}
          pageType="business"
        />
      </Modal.Body>

      {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary">Save</Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default AddContactModal;
